// หน้าเนื้อหาทั่วไปของเมนูที่ยังไม่มีของจริงมาแสดง (Finance / Strategy / Data /
// Content › Graphic Library) — โครงเดียวกับ renderBrandContent() เดิม
//
// Overview (Phase 5) และ Ads › Campaigns (Phase 6) จะมาแทนที่หน้านี้ตามเมนูของตัวเอง
import { useSearchParams } from "react-router";
import type { Brand } from "@contracts/api";
import { useCampaigns } from "@features/campaigns/api/use-campaigns";
import { CampaignSelect } from "@features/campaigns/components/campaign-select";
import { SIDE_MENUS } from "@features/navigation/model/side-menus";
import { IconChat, IconChevronRight, IconFlag } from "@shared/ui/icons";
import { BrandLogo } from "../components/brand-logo";

export function BrandDashboard({
  brand,
  menuId,
  sub,
}: {
  brand: Brand;
  menuId: string;
  sub?: string;
}) {
  const [params] = useSearchParams();
  const { data: campaigns } = useCampaigns(brand.id);
  const list = campaigns ?? [];

  const menu = SIDE_MENUS.find((m) => m.id === menuId);
  const title = menu ? menu.label : "Dashboard";
  const subLabel = menu?.submenu.find((s) => s.slug === sub)?.label ?? sub;

  const selectedId = params.get("campaign") ?? "";
  const selected = list.find((c) => c.id === selectedId) ?? null;

  return (
    <>
      <div className="content-head">
        <div>
          <div className="breadcrumb">
            {brand.name}
            {menu ? " / " + title : ""}
            {subLabel ? " / " + subLabel : ""}
          </div>
          <h1>{subLabel || title}</h1>
        </div>
        <div className="head-actions">
          <CampaignSelect campaigns={list} showCount />
          <button type="button" className="btn-outline">
            ✏️&nbsp; Add use cases
          </button>
        </div>
      </div>

      <div className="ads-scope-bar">
        {selected ? `แสดงข้อมูล Ads ของแคมเปญ: ${selected.name}` : "แสดงข้อมูล Ads รวมทุกแคมเปญ"}
      </div>

      <div className="panel">
        <h3>Required actions</h3>
        <p className="muted">
          ยังไม่มีรายการที่ต้องดำเนินการสำหรับ {brand.name} หากมีงานที่ต้องจัดการเร่งด่วน
          รายการจะแสดงที่นี่
        </p>
      </div>

      <div className="panel-grid">
        <div className="panel">
          <h3>Performance</h3>
          <div style={{ display: "flex", alignItems: "center", gap: 14, margin: "14px 0 6px" }}>
            <BrandLogo brand={brand} className="brand-logo" />
            <div>
              <div style={{ fontWeight: 700, fontSize: 16 }}>{brand.name}</div>
              <div className="muted" style={{ fontSize: 13 }}>
                {brand.tagline}
              </div>
            </div>
          </div>
          <div className="muted" style={{ marginTop: 10, fontWeight: 600 }}>
            0% of limit used
          </div>
          <div className="progress">
            <span style={{ width: "2%" }} />
          </div>
        </div>
        <div className="panel">
          <h3>Active Campaigns</h3>
          <div className="stat-big" style={{ marginTop: 14 }}>
            {/* ระหว่างที่ยังโหลดรายชื่อแคมเปญไม่เสร็จ ใช้ตัวเลขที่มาพร้อมแบรนด์ก่อน
                จะได้ไม่เห็น 0 แว่บหนึ่งแล้วเด้งเป็นเลขจริง */}
            <div className="num">
              {selected ? 1 : campaigns ? list.length : brand.stats.campaigns}
            </div>
            <div className="cap">{selected ? "แคมเปญที่เลือก" : "Campaigns ทั้งหมด"}</div>
          </div>
        </div>
      </div>

      <div className="panel">
        <h3>Use cases on this brand</h3>
        <a className="list-row" href="#">
          <span className="row-icon">
            <IconChat />
          </span>
          <span className="grow">Engage with customers on Messenger</span>
          <span className="chev">
            <IconChevronRight />
          </span>
        </a>
        <a className="list-row" href="#">
          <span className="row-icon">
            <IconFlag />
          </span>
          <span className="grow">Manage everything on your Page</span>
          <span className="chev">
            <IconChevronRight />
          </span>
        </a>
      </div>
    </>
  );
}
